import AdminTab from 'app/components/AdminTab';
import { PageMainLabel } from 'app/components/SHLabel';
import styled from 'styled-components';
import BackButton from 'app/components/BackButton';
import { CommonPageWrapper } from 'admin/components/wrappers';
import CustomBreadCrumb from 'app/components/CustomBreadCrumb';
import { useEffect, useState } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import { useNavigateToRoute } from 'utils/common';
import { ShowViewProfile } from './Components/ShowViewProfile/ShowViewProfile';
import { tabShowsNamesArray } from './Components/ShowViewProfile/staticData';
import useShowApi from 'admin/hooks/useShowApi';
import ShowManageRider from './Components/ShowManageRider';
import { ShowRegistration } from 'services/openapi';
import Cookies from 'js-cookie';
import { usePermission } from 'hooks/usePermission';
import { FormSkeletonLoader } from 'app/components/FormSkeletonLoader';

export const ShowIndividual = () => {
  const userType = Cookies.get('userType') ?? '';
  const { id: showId } = useParams();
  const redirect = useNavigateToRoute();
  const { hasViewPermission } = usePermission();
  const [tabSelected, setTabSelected] = useState<number>(0);
  const location = useLocation();
  const isPastDataFlag = location.pathname.includes('past-data');
  const [showData, setShowData] = useState<ShowRegistration>();
  const showsViewbreadCrumpitems = [
    {
      id: '',
      text: userType === 'COACH' ? 'Showyeda coach' : 'Showyeda admin',
      disabled: true,
    },
    {
      id: '/admin/shows',
      text: 'Shows',
    },
    {
      id: '',
      text: 'Shows Info',
      disabled: true,
    },
  ];
  const handleBackClick = () => {
    window.history.back();
  };
  const onTabSelectRedirect = e => {
    const { selected } = e;
    Cookies.set('teamsTab', selected);
    switch (selected) {
      case 0:
        if (isPastDataFlag) {
          redirect(
            userType === 'COACH'
              ? `/coach/past-data/shows/${showId}/show-info/view`
              : `/admin/past-data/shows/${showId}/show-info/view`,
          );
        } else {
          redirect(
            userType === 'COACH'
              ? `/coach/shows/view/${showId}/show-info`
              : `/admin/shows/view/${showId}/show-info`,
          );
        }
        break;
      case 1:
        if (isPastDataFlag) {
          redirect(
            userType === 'COACH'
              ? `/coach/past-data/shows/view/manage-rider/${showId}`
              : `/admin/past-data/shows/view/manage-rider/${showId}`,
          );
        } else {
          redirect(
            userType === 'COACH'
              ? `/coach/shows/view/${showId}/manage-rider`
              : `/admin/shows/view/${showId}/manage-rider`,
          );
        }
        break;
      default:
        return '';
    }
  };
  const {
    getShowInfo,
    showInfoData: showViewData,
    showDataLoading: loading,
  } = useShowApi();

  useEffect(() => {
    if (location.pathname.includes('/shows/view') && showId) {
      getShowInfo(showId ?? '');
    }
  }, [location, showId]);

  useEffect(() => {
    setShowData(showViewData);
  }, [showViewData]);

  useEffect(() => {
    if (location.pathname.includes('show-info')) {
      setTabSelected(0);
    } else if (location.pathname.includes('manage-rider')) {
      setTabSelected(1);
    }
  }, [location.pathname]);
  const permissionTab = tabShowsNamesArray.filter(item =>
    hasViewPermission(item.permissionId),
  );
  return (
    <StyledCommonPageWrapper>
      <HeadingWrapper>
        {loading ? (
          <SkeletonWrapper>
            <FormSkeletonLoader textWidth={300} textHeight={32} />
          </SkeletonWrapper>
        ) : (
          <PageMainLabel>
            Shows Information - {`(${showViewData?.showName})` as string}
          </PageMainLabel>
        )}
        <CustomBreadCrumb preData={showsViewbreadCrumpitems} />
      </HeadingWrapper>
      <TabWrapper
        className={
          tabSelected === 0
            ? 'show-info'
            : tabSelected === 1
              ? 'manage-rider'
              : ''
        }
      >
        <AdminTab
          data={permissionTab}
          tabSelected={tabSelected}
          setTabSelected={setTabSelected}
          onTabSelect={onTabSelectRedirect}
        />
        <BackButton className="back-button" onClick={handleBackClick} />
      </TabWrapper>
      {tabSelected === 0 && hasViewPermission('0500101003') && (
        <ShowViewProfile showData={showData} loading={loading} />
      )}
      {tabSelected === 1 && hasViewPermission('0500101004') && (
        <ShowManageRider showName={showViewData?.showName} />
      )}
    </StyledCommonPageWrapper>
  );
};
const HeadingWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;
const TabWrapper = styled.div`
  position: relative;
  &.rides-info {
    .hPRKpe {
      margin: 0 0 2px 0;
    }
  }

  .back-button {
    cursor: pointer;
    position: absolute;
    right: -12px;
    top: 7px;
    z-index: 2;
    span {
      font-weight: 500;
    }
  }

  .user-count-tab .k-item.k-last {
    color: unset !important;
  }
`;
const StyledCommonPageWrapper = styled(CommonPageWrapper)`
  padding: 20px 40px 20px 40px;
  .k-breadcrumb {
    .k-breadcrumb-last-item {
      .k-breadcrumb-link {
        padding: 0 1px 0 3px;
      }
    }
  }
`;

const SkeletonWrapper = styled.div`
  margin-bottom: 10px;
  .react-loading-skeleton {
    --base-color: #b7bdbe2b;
    --highlight-color: #f5f5f58f;
  }
`;
